<template>
  <spinner-container :loading="localLoading">
    <bread-cump :cumps="cumps" />
    <v-row justify="center">
      <v-col cols="12" md="6">
        <township-form
          :township="township"
          @emitTownshipData="updateTownship"
        />
      </v-col>
    </v-row>
  </spinner-container>
</template>

<script>
import TownshipForm from "@/components/township/TownshipForm";
import { mapState } from "vuex";
import BreadCump from "@/components/navigation/BreadCump";
import SpinnerContainer from "@/components/container/SpinnerContainer.vue";

export default {
  components: {
    TownshipForm,
    BreadCump,
    SpinnerContainer,
  },
  data: () => ({
    cumps: [
      {
        text: "Home",
        disabled: false,
        href: "/",
      },
      {
        text: "Townships",
        disabled: false,
        href: "/township",
      },
      {
        text: "Township Form",
        disabled: true,
      },
    ],
  }),
  computed: {
    ...mapState("Township", ["township"]),
    ...mapState("Loading", ["localLoading"]),
  },
  methods: {
    updateTownship(payload) {
      this.$store.dispatch("Township/updateTownship", payload).then(() => {
        this.$router.push({ name: "township" });
      });
    },
  },
  created() {
    this.$store.dispatch("Loading/changeLocalLoading");
    this.$store
      .dispatch("Township/getTownship", this.$route.params.id)
      .then(() => {
        this.$store.dispatch("Loading/changeLocalLoading");
      });
  },
};
</script>
